import script from "./ChevronUpIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ChevronUpIcon.vue?vue&type=script&setup=true&lang=js"

export default script